export const header = [
  'City',
  'Week',
  'Date',
  'Time',
  'Time of day',
  'Day of week',
  'Spy',
  'Location',
  'BA',
  'Code',
  'Tag',
  'Flyers distributed',
  'Status',
  'Scans',
]
// The headers for the csv export file
export const exportHeaders = [
  'City',
  'Week',
  'Date',
  'Day of week',
  'Time',
  'Time of day',
  'Location',
  'Location Type',
  'BA',
  'Code',
  'Tag',
  'Pack Size',
  'Flyers distributed',
  'Distribution Cost',
  'Printing Cost',
  'Permit Cost',
  'Cash Bonus',
  'Hard Cost',
  'Scans',
]
export const sortOn = [
  'City',
  'Date',
  'Time',
  'Time of day',
  'Day of week',
  'Week',
  'Location',
  'BA',
  'Code',
  'Flyers distributed',
  'Status',
]

export const getDynamicHeaders = (headers, metrics, exportMode = false) => {
  const headersClone = [...headers]
  // Add the metrics to the header and make them sortable
  metrics.forEach(({ name }) => {
    headersClone.push(name)
    headersClone.push(`Cost per ${name}`)
    headersClone.push(`${name} CVR`)
  })

  exportMode && headersClone.splice(headersClone.length, 0, 'Status', 'Link')

  return headersClone
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/MasterSchedule/tableSettings.js